import styles from "../ShiftsModal.module.scss";
import { memo } from "react";

const ApproveActionHeader = () => (
  <div className={styles.header}>Подтвердите действие</div>
)

export default memo(ApproveActionHeader);
